import { NodeModel } from "@minoru/react-dnd-treeview";
import { TagFromTree } from "../models/TagsTree.model";

export function buildTagsTree(data: TagFromTree[]) {
	const nodeMap = new Map();

	// Step 1: Create node entries in the map.
	data.forEach((item) => {
		nodeMap.set(item.TagId, { ...item, children: [] });
	});

	// Step 2: Build the tree by linking nodes to their parents.
	const rootNodes: TagFromTree[] = [];
	data.forEach((item) => {
		if (item.ParentTagId === null) {
			// This is a root node.
			rootNodes.push(nodeMap.get(item.TagId));
		} else {
			// Find the parent node in the map and add this node as a child.
			const parentNode = nodeMap.get(item.ParentTagId);
			if (parentNode) {
				parentNode.children.push(nodeMap.get(item.TagId));
			} else {
				// If parent is not found, consider this as a root node.
				// This situation shouldn't happen in a well-formed tree,
				// unless the parent ID is invalid.
				rootNodes.push(nodeMap.get(item.TagId));
			}
		}
	});

	// This will return the array of root nodes.
	return rootNodes;
}

export function buildTagsTreeV2(data: TagFromTree[]): NodeModel<TagFromTree>[] {
	const tagsForTree: NodeModel<TagFromTree>[] = [];

	data.forEach((el) => {
		const tagForTree: NodeModel<TagFromTree> = {
			id: el.TagId,
			parent: el.ParentTagId || 0,
			text: el.TagName,
			data: el,
			droppable: el.TagTypeCode === "F",
		};
		return tagsForTree.push(tagForTree);
	});
	return tagsForTree;
}
